<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ds7334/tc-custom/9781449488246.jpg?1729379484826" alt="This image is the cover for the book Ask Baba Yaga"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ask Baba Yaga
      </h1>
      <p class="bookDescription body article font2">
        <i>Dear Baba Yaga,</i><br/><i>I think I must crave male attention too much. I fear that, without it, I would feel invisible.</i><br/> <br/><i>BABA YAGA:</i><br/><i>When you seek others this way, you are invisible nonetheless. Yr shawl is covered in mirrors in which others admire themselves; this is why they greet you so passionately. It is good to be seen, but it is better to see. Find a being to look hard into, &amp; you will see yrself and what is more than you.</i><br/> <br/>In age-old Slavic fairy tales, the witch Baba Yaga is sought out by those with a burning need for guidance. In contemporary life, Baba Yaga—a dangerous, slippery oracle—answered earnest questions on The Hairpin for years. These pages collect her most poignant, surreal, and humorous exchanges along with all-new questions and answers for those seeking her mystical advice.<br/> 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Taisia Kitaiskaia
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ad3747c4